import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CourseMaster } from '../model/CourseMaster.model';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { LectureMaster } from '../model/LectureMaster.model';
import { StudentLectureMaster } from '../model/StudentLectureMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import {MessageService} from 'primeng/api';
import { CompanyDetailMaster } from '../model/CompanyDetailMaster.model';
import { TrainerMaster } from '../model/TrainerMaster.model';
import { NgxSpinnerService } from 'ngx-spinner';


declare var require: any
 const FileSaver = require('file-saver');
@Component({
  selector: 'app-my-coursedetails',
  templateUrl: './my-coursedetails.component.html',
  styleUrls: ['./my-coursedetails.component.scss']
})
export class MyCoursedetailsComponent implements OnInit {
  enrollCourseMaster:EnrollCourseMaster=new EnrollCourseMaster();
  activeState: boolean[] = [true, false, false];
  gallerycarousel : any;
  showDialog: boolean=false;
  showDialog1: boolean=false;
  imagecarousel:any;
  trainerMasterTemp:TrainerMaster=new TrainerMaster();
  valueTrainer:boolean=false;
  showDialogTrainer:boolean=false;
  totalRecords:number=0;
  showbtn:boolean=true;

  value: boolean=false;
  value1: boolean=false;
  courselistTemp:CourseMaster=new CourseMaster();
  courseMasterList: CourseMaster[]=[];

  pageSize: number = 5;
  pageNumber: number = 0
  companyDetailMaster:CompanyDetailMaster = new CompanyDetailMaster();
 showErrorCheckbox:string="";

  constructor(private mainService:MainserviceService,private authService:AuthService,private router:Router, private messageService: MessageService,public spinnerService: NgxSpinnerService ) { }

  ngOnInit() {
this.spinnerService.show()
    this.getEnrollCourseMasterById();
    this.getCourseMasterList();
    this.getCompanyDetail();

    this.gallerycarousel = {
      loop: false,
      autoplay: false,
      margin: 20,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 4,
      navSpeed: 1000,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }
        
        
      },
      nav: true
    }

    this.imagecarousel = {
      loop: false,
      autoplay: false,
      margin: 1000,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 1,
      navSpeed: 500,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }
        
        
      },
      nav: true
    }
     
  }

  toggle(index: number) {
    this.activeState[index] = !this.activeState[index];
  }

  getEnrollCourseMasterById(){
    this.enrollCourseMaster = this.authService.getEnrollCourseMasterSession();
    this.mainService.getEnrollCourseMasterById(this.enrollCourseMaster).subscribe(data => {
      this.enrollCourseMaster = data;
this.spinnerService.hide()

   }, (err: HttpErrorResponse) => {
     if (err.status === 200) {
       let jsonString = err.error.text;
       jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
       // this.packageServiceList = JSON.parse(jsonString);

     }


   })


  }


 


  viewDialogTrainer(trainerMaster:TrainerMaster){
    this.trainerMasterTemp=new TrainerMaster()
    this.trainerMasterTemp=trainerMaster;
    this.showDialogTrainer=true;
    
  }
  

  viewChapter(studentLectureMaster:StudentLectureMaster){
    this.authService.setlectureMasterSession(studentLectureMaster);
    let user=this.authService.getUserSession();
    if(user!=null && user!=undefined && user.studentMasterId!=undefined){
      this.router.navigateByUrl('/chapter-details');
    }else{
    this.router.navigateByUrl('/login');
    }
  }


  getCourseMasterList() {

    this.courselistTemp.isMasterCourse=false;
  
    this.courselistTemp.pageNumber = this.courselistTemp.pageNumber
      ? this.courselistTemp.pageNumber
      : this.pageNumber;
    this.courselistTemp.pageSize = this.courselistTemp.pageSize
      ? this.courselistTemp.pageSize
      : this.pageSize;
    
    this.mainService.getCourseMasterList(this.courselistTemp).subscribe(
      (data) => {
        this.courseMasterList = data;
        this.getCourseMasterListLength();
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  chapterIncomplete(){
    this.messageService.add({severity:'error', summary:'Please Complete', detail:'Previous Video.'});
  }
  


  getCourseMasterListLength() {
   


    this.courselistTemp.isMasterCourse=false;


    this.mainService.getCourseMasterListLength(this.courselistTemp).subscribe(data => {
      this.totalRecords = data;
      
    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.courselistTemp = JSON.parse(jsonString);

      }


    })
  }

  incrementPage(){

    this.courselistTemp.pageNumber=this.courselistTemp.pageNumber
    this.courselistTemp.pageSize=this.courselistTemp.pageSize+5
    
    this.getCourseMasterList();
    
    if(this.courselistTemp.pageSize>=this.totalRecords){
     
      this.showbtn=false;
    }
    
  }




  startExamDialog(){
    this.showDialog=true;
    
}

  viewExam(){
    if(this.value==false){
      this.showErrorCheckbox="You Need to Agree these Rule"

   }
   else{
    this.showErrorCheckbox="";
    this.router.navigateByUrl('/exam');
     
   }

  }


  downloadFile(fileUrl:string) {

    if(fileUrl === null){
      this.messageService.add({severity:'error', summary:'No Certificate', detail:'available'});
        return;
    }
  
    var fileUrlSplit = fileUrl.split("/");
  
    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length-1]);
  
  }
  
  
  downloadCertificate() {
  
    if(this.enrollCourseMaster.examResultFilePath!=null){
    this.downloadFile(this.enrollCourseMaster.examResultFilePath);
  }else{
    this.messageService.add({severity:'error', summary:'No Certificate', detail:'available'});
  }
  }

  viewDialog(){
    this.showDialog1=true;
  
  }


  getCompanyDetail(): any {
    // this.spinnerService.show();
  
    this.mainService.getCompanyDetail(new CompanyDetailMaster()).subscribe(
      data => {
        this.companyDetailMaster = data;
        // this.spinnerService.hide();
      },
      error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
         //   this.spinnerService.hide();
            let data = JSON.parse(jsonString);
            this.companyDetailMaster = data;
          } else {
            this.authService.showMessage('error','Something went wrong', '');
          //  this.spinnerService.hide();
          }
          // this.spinnerService.hide();
        }
      }
    );
  }


  viewCourse(courseMaster:CourseMaster){
    this.authService.setcourseMasterSession(courseMaster);
    this.router.navigateByUrl('/course-details');
    
  }

  takeAssessment(studentLectureMaster: StudentLectureMaster){

    this.authService.setlectureMasterSession(studentLectureMaster);
    this.router.navigateByUrl('/assessment');

  }


}
